import getSmarttagsKeys from '../getSmarttagsKeys';
import getSmarttagsValues from '../getSmarttagsValues';
import getSmarttags from '../getSmarttagsByFts';
var TagmanagerConnector = function (_a) {
    var accessToken = _a.accessToken, appId = _a.appId, appspace = _a.appspace, children = _a.children;
    var getKeys = function (key) {
        return getSmarttagsKeys({
            appId: appId,
            appspace: appspace,
            accessToken: accessToken,
        }, key);
    };
    var getValues = function (key, value) {
        return getSmarttagsValues({
            appId: appId,
            appspace: appspace,
            accessToken: accessToken,
        }, key, value);
    };
    var getSmarttagsByFts = function (q) {
        return getSmarttags({
            appId: appId,
            appspace: appspace,
            accessToken: accessToken,
        }, q);
    };
    return children(getKeys, getValues, getSmarttagsByFts);
};
export default TagmanagerConnector;
